import { REVIEW_VIEW } from "../../status";
import type { ColumnVisibilityModel } from "../DataTable";

// MUI's toggle field name, so column orders saved by the old grid still fit.
export const DETAIL_TOGGLE_FIELD = "__detail_panel_toggle__";

export const DEFAULT_COLUMN_ORDER: string[] = [
  DETAIL_TOGGLE_FIELD,
  "claimStatus",
  "practiceDisplayName",
  "payer",
  "wieldyPatientName",
  "claimId",
  "dateOfService",
  "claimPayerPays",
  "postedState",
  "action",
  "denialStatus",
  "denialUrgency",
  "doneButton",
  "takeActionButton",
  "daysSinceService",
  "daysSinceNotice",
  "claimType",
  "bankMatchState",
  "postedByActor",
  "reviewStatus",
  "claimGroupName",
  "claimGroupNumber",
  "patientPayerNetwork",
  "wieldyStatus",
  "urgency",
  "paymentId",
  "claimPriorPaidAmount",
  "patientDob",
  "wieldySubscriberName",
  "subscriberId",
  "relationshipToSubscriber",
  "availableSince",
  "wieldyClaimDate",
  "postedDateTime",
  "notes",
  "documents",
];

export const getDefaultColumnVisibility: () => ColumnVisibilityModel = () => ({
  action: true,
  availableSince: true,
  bankMatchState: false,
  claimGroupName: false,
  claimGroupNumber: false,
  claimId: true,
  claimPayerPays: true,
  claimPriorPaidAmount: false,
  claimStatus: true,
  claimType: false,
  documents: true,
  notes: true,
  patientDob: false,
  patientPayerNetwork: false,
  paymentId: true,
  payer: true,
  postedDateTime: true,
  postedState: true,
  practiceDisplayName: true,
  renderingProviderId: false,
  relationshipToSubscriber: false,
  reviewStatus: false,
  subscriberId: false,
  urgency: true,
  wieldyClaimDate: false,
  wieldyPatientName: true,
  postedByActor: false,
  wieldySubscriberName: false,
  wieldyStatus: false,
  dateOfService: false,
  denialStatus: false,
  denialUrgency: false,
  doneButton: false,
  takeActionButton: false,
  daysSinceNotice: false,
  daysSinceService: false,
});

export const getReviewColumnVisibility = (
  isDeniseEnabled: boolean,
  activeView?: REVIEW_VIEW | null,
): ColumnVisibilityModel => {
  const defaultVisibility = getDefaultColumnVisibility();
  const allHidden: ColumnVisibilityModel = Object.fromEntries(
    Object.keys(defaultVisibility).map((k) => [k, false]),
  );
  const base: ColumnVisibilityModel = {
    ...allHidden,
    claimStatus: true,
    practiceDisplayName: true,
    payer: true,
    wieldyPatientName: true,
    claimId: true,
    claimPayerPays: true,
    postedState: true,
    documents: true,
    dateOfService: true,
  };
  if (!isDeniseEnabled) return base;

  const withDenise: ColumnVisibilityModel = {
    ...base,
    denialStatus: true,
    action: true,
    doneButton: true,
  };

  if (activeView === REVIEW_VIEW.DENISE) {
    return {
      ...allHidden,
      practiceDisplayName: true,
      payer: true,
      wieldyPatientName: true,
      claimId: true,
      dateOfService: true,
      daysSinceNotice: true,
      denialUrgency: true,
      action: true,
      takeActionButton: true,
      documents: true,
    };
  }
  if (activeView === REVIEW_VIEW.POSTIE) {
    return {
      ...withDenise,
      denialStatus: false,
      action: false,
      doneButton: false,
    };
  }
  return withDenise;
};

export const getAllClaimsColumnVisibility = (
  isDeniseEnabled: boolean,
): ColumnVisibilityModel => {
  const defaultVisibility = getDefaultColumnVisibility();
  const allHidden: ColumnVisibilityModel = Object.fromEntries(
    Object.keys(defaultVisibility).map((k) => [k, false]),
  );
  const base: ColumnVisibilityModel = {
    ...allHidden,
    claimStatus: true,
    practiceDisplayName: true,
    payer: true,
    wieldyPatientName: true,
    claimId: true,
    dateOfService: true,
    claimPayerPays: true,
    postedState: true,
    action: true,
    documents: true,
  };
  if (isDeniseEnabled) {
    return {
      ...base,
      denialStatus: true,
      takeActionButton: true,
    };
  }
  return base;
};

export const getDenialsColumnVisibility = (
  isDeniseEnabled: boolean,
): ColumnVisibilityModel => {
  const defaultVisibility = getDefaultColumnVisibility();
  const allHidden: ColumnVisibilityModel = Object.fromEntries(
    Object.keys(defaultVisibility).map((k) => [k, false]),
  );
  const base: ColumnVisibilityModel = {
    ...allHidden,
    claimStatus: true,
    practiceDisplayName: true,
    payer: true,
    wieldyPatientName: true,
    claimId: true,
    dateOfService: true,
    claimPayerPays: true,
    action: true,
    documents: true,
  };
  if (isDeniseEnabled) {
    return {
      ...base,
      denialStatus: true,
      takeActionButton: true,
      daysSinceNotice: false,
      daysSinceService: true,
    };
  }
  return base;
};
